import { useMemo, useState } from "react";

// Comparator thuần (không phải hook) — dùng để sort trong từng nhóm trạng thái ở trang promoter.
export function compareSales(sortKey, dir) {
  return (a, b) => {
    let av, bv;
    if (sortKey === "promoterName") { av = a.promoterName || ""; bv = b.promoterName || ""; }
    else if (sortKey === "model") { av = a.model || ""; bv = b.model || ""; }
    else { av = a.saleDate || ""; bv = b.saleDate || ""; }
    const cmp = av.localeCompare(bv, "vi", { numeric: true, sensitivity: "base" });
    return dir === "asc" ? cmp : -cmp;
  };
}

// Hook sắp xếp danh sách doanh số theo promoter / model / ngày bán.
// Dùng chung cho admin, supervisor, promoter.
export function useSalesSort(list, defaultKey = "saleDate", defaultDir = "desc") {
  const [sortKey, setSortKey] = useState(defaultKey);
  const [dir, setDir] = useState(defaultDir);

  const toggle = (key) => {
    if (key === sortKey) {
      setDir(d => (d === "asc" ? "desc" : "asc"));
    } else {
      setSortKey(key);
      setDir(key === "saleDate" ? "desc" : "asc");
    }
  };

  const sorted = useMemo(() => {
    const arr = [...(list || [])];
    arr.sort((a, b) => {
      let av, bv;
      if (sortKey === "promoterName") { av = a.promoterName || ""; bv = b.promoterName || ""; }
      else if (sortKey === "model") { av = a.model || ""; bv = b.model || ""; }
      else { av = a.saleDate || ""; bv = b.saleDate || ""; } // saleDate: chuỗi yyyy-MM-dd so sánh trực tiếp
      const cmp = av.localeCompare(bv, "vi", { numeric: true, sensitivity: "base" });
      return dir === "asc" ? cmp : -cmp;
    });
    return arr;
  }, [list, sortKey, dir]);

  const arrow = (key) => (key === sortKey ? (dir === "asc" ? " ▲" : " ▼") : "");

  return { sorted, sortKey, dir, toggle, arrow };
}
